import React from 'react';
import styles from './LocationHours.module.css';

const LocationHours = () => {
  // Update address to the new one
  const address = "909 E Main St, Richmond, VA";
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  // Reverted hours data
  const hours = [
    { day: "Monday", time: "7:30 AM – 5:30 PM" },
    { day: "Tuesday", time: "7:30 AM – 5:30 PM" },
    { day: "Wednesday", time: "7:30 AM – 5:30 PM" },
    { day: "Thursday", time: "7:30 AM – 5:30 PM" },
    { day: "Friday", time: "7:30 AM – 5:30 PM" },
    { day: "Saturday", time: "Closed" },
    { day: "Sunday", time: "Closed" },
  ];

  return (
    <section id="location-hours" className={styles.locationHours}>
      <div className={styles.container}>
        <h2 className={styles.locationHoursTitle}>Visit Us</h2>
        <div className={styles.contentWrapper}>
          {/* Hours Info */}
          <div className={styles.infoBlock}>
            <img src="/symbols/clock.png" alt="Clock" className={styles.icon} />
            <h3>Opening Hours</h3>
            <ul className={styles.hoursList}>
              {hours.map((item, index) => (
                <li key={index}>
                  <strong>{item.day}:</strong> {item.time}
                </li>
              ))}
            </ul>
          </div>

          {/* Location Info */}
          <div className={styles.infoBlock}>
            <img src="/symbols/location.png" alt="Location Pin" className={styles.icon} />
            <h3>Our Location</h3>
            <p>
              <a href={googleMapsLink} target="_blank" rel="noopener noreferrer" className={styles.addressLink}>
                {address}
              </a>
            </p>
          </div>
        </div>

        {/* Google Map Embed */}
        <div className={styles.mapContainer}>
          <iframe 
            src={`https://maps.google.com/maps?q=${encodeURIComponent(address)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
            width="100%" 
            height="400" 
            style={{ border:0 }}
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title={`Map showing location of ${address}`}
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default LocationHours;
